import React, { useState } from 'react';
import { useAppContext } from '../contexts/AppContext';

const DesktopHeader = () => {
  const { searchQuery, setSearchQuery, notifications, user } = useAppContext();
  const [focused, setFocused] = useState(false);

  const today = new Date().toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });

  return (
    <div className="desktop-header">
      <div className="desktop-header-left">
        <div className="desktop-title">Fleet Dashboard</div>
        <div className="desktop-sub">Welcome back, {user?.name?.split(' ')[0] || 'Manager'} — manage your fleet in one place.</div>
      </div>

      <div className="desktop-search">
        <div className={`search-inner ${focused ? 'focused' : ''}`}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="11" cy="11" r="8" />
            <path d="M21 21l-4.35-4.35" />
          </svg>
          <input
            type="search"
            placeholder="Search for vehicle, driver, account..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            onFocus={() => setFocused(true)}
            onBlur={() => setFocused(false)}
          />
        </div>
      </div>

      <div className="desktop-toolbar">
        <div className="desktop-date">{today}</div>
        <button className="topbar-btn">
          <svg width="18" height="18" viewBox="0 0 20 20" fill="currentColor">
            <path d="M10.5 1.5H4a2.5 2.5 0 00-2.5 2.5v10a2.5 2.5 0 002.5 2.5h12a2.5 2.5 0 002.5-2.5V4a2.5 2.5 0 00-2.5-2.5h-6.5m0 5h6m-6 4h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
          </svg>
        </button>
        <button className="topbar-btn">
          <svg width="18" height="18" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M3 5a2 2 0 012-2h10a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2V5zm11 1H4v8h10V6z" clipRule="evenodd" />
          </svg>
          {notifications.length > 0 && <span className="notification-badge">{notifications.length}</span>}
        </button>
        <div className="desktop-user-badge">{user?.name?.split(' ').map((n) => n[0]).join('').slice(0, 2)}</div>
      </div>
    </div>
  );
};

export default DesktopHeader;
